import * as React from "react";

const CloseNotification: React.FC = () => {
    return (
        <svg width="21" height="21" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M8.758 18.677c-.886-1.35-1.13-1.667-1.851-2.407-.274-.28-.936-.894-1.472-1.365C4.297 13.908 4 13.634 4 13.578c0-.098.698-.705 1.821-1.583.873-.683 1.053-.798 1.25-.798h.158l.193.445c.437 1.007 1.064 2.38 1.164 2.548.125.211.261.277.394.19.11-.07.544-.911.998-1.93a52.652 52.652 0 0 1 1.752-3.47c.643-1.14 1.514-2.483 1.977-3.048.632-.77 2.006-2.006 2.1-1.914.015.014-.32.211-.25.147.938-.855.037 1.729.398 4.58.114.902-.013.952-.37 1.252-1.205 1.012-1.71 1.54-2.587 2.703-1.563 2.072-2.52 3.594-3.415 5.427-.18.37-.361.72-.401.776-.122.167-.188.131-.424-.227Z" fill="#002554" fill-rule="nonzero" /><circle stroke="#002554" stroke-width="1.5" cx="10.5" cy="10.5" r="9.75" /></g></svg>
    );
};


export default React.memo(CloseNotification);
